import CasesList from "./CasesList";

export default CasesList;
